import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken, getOrganizeId, getCampusId } from '@/utils/cookies' // 验权
import { getStore } from '@/utils/index'
import domain from '@/utils/domain'
import { UserModule } from '@/store/modules/user'
import router from '@/router/index'

let postLang = 'zh_CN'
if (getStore('lang') === 'cn') {
  postLang = 'zh_CN'
} else if (getStore('lang') === 'en') {
  postLang = 'en_US'
} else if (getStore('lang') === 'tw') {
  postLang = 'zh_TW'
}

var params = {}
// 字符串参数 转 json
function xxxToJson(str:string) {
  var t
  var n
  var r
  var i = str
  var json = {}
  t = i.split('&')
  r = null
  n = null
  for (var o in t) {
    var u = t[o].indexOf('=')
    // eslint-disable-next-line no-unused-expressions
    u !== -1 && (r = t[o].substr(0, u),
    n = t[o].substr(u + 1),
    // @ts-ignore
    json[r] = n)
  }
  return json
}
// 创建axios实例
const service = axios.create({
  baseURL: domain.BASE_API, // api的base_url
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'Content-Type': 'application/json',
    apptype: 100,
    clienttype: 100,
    language: postLang
  },
  timeout: 15000, // 请求超时时间
  transformRequest: [
    function(data) {
      // Do whatever you want to transform the data
      let ret = ''
      params = data
      for (const key in params) {
        const newKey = encodeURIComponent(key)
        // 检查value值 如果值为数组或对象 先转成Json字符串 再传值
        let newValue = ''
        if (
          typeof data[key] === 'object' &&
          data[key] !== null &&
          data[key] !== undefined
        ) {
          // console.log('监测到对象元素' + key)
          newValue = encodeURIComponent(JSON.stringify(data[key]))
        } else {
          newValue = encodeURIComponent(data[key])
        }
        ret += newKey + '=' + newValue + '&'
      }
      ret = ret.substring(0, ret.length - 1)
      return ret
    }
  ]
})

// request拦截器
service.interceptors.request.use(
// @ts-ignore
  config => {
    let organizeId
    let campusId
    let token
    if (UserModule.token) {
      token = UserModule.token
    } else {
      token = getToken() || ''
    }
    if (UserModule.organizeId) {
      organizeId = UserModule.organizeId
    } else {
      organizeId = getOrganizeId() || null
    }
    if (UserModule.campusId) {
      campusId = UserModule.campusId
    } else {
      campusId = getCampusId() || null
    }
    // if (accesstoken && !rootId) {
    //   logoutDialog('当前登录已失效，请重新登录')
    //   return
    // }
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['organize'] = organizeId
    config.headers['campus'] = campusId
    return config
  },
  (error: any) => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const { data, config } = response
    if (data && data.status === undefined) {
      return data
    } else {
      if (data.status !== 'succ') {
        if (data.code === 40001) { // 登录失效
          Message({
            message: '登录失效请重新登录',
            type: 'error',
            duration: 3000
          })
          store.dispatch('FELogOut').then(() => {
            setTimeout(() => {
              router.replace('/login')
              window.location.reload() // 为了重新实例化vue-router对象 避免bug
            }, 3000)
          })
        } else if (data.code === 40002) { // 临时失效-无感刷新token
          // console.log('token 临时失效')
          // console.log(response)
          let url = config.url
          let requestData = xxxToJson(decodeURIComponent(config.data))
          // 新token存在message中
          // let newToken = data.message
          UserModule.SetToken(data.message)
          // 重新发送请
          // console.log(requestData)
          return service({
            url: url,
            method: 'post',
            data: requestData
          })
        } else if (data.code === 40010) { // 用户权限变更，退出登录 防止报错
          Message({
            message: data.message,
            type: 'error',
            duration: 3000
          })
          store.dispatch('FELogOut').then(() => {
            setTimeout(() => {
              router.replace('/login')
              window.location.reload() // 为了重新实例化vue-router对象 避免bug
            }, 3000)
          })
        } else {
          Message({
            message: data.message,
            type: 'error',
            duration: 3000
          })
        }
        return Promise.reject(new Error(data.message))
      } else {
        return data
      }
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
